var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ClearIcon from '@mui/icons-material/Clear';
import { Box, Button, Container, Drawer, Grid2 as Grid, MenuItem, TextField, Typography, } from '@mui/material';
import React, { useState } from 'react';
import { useList } from './ListContext';
export var FilterComponent = function (_a) {
    var _b = _a.color, color = _b === void 0 ? 'white' : _b;
    var _c = useList(), filters = _c.filters, filterFields = _c.filterFields, setFilters = _c.setFilters;
    var _d = useState(false), open = _d[0], setOpen = _d[1];
    var _e = useState(__assign({}, filters)), localFilters = _e[0], setLocalFilters = _e[1];
    var toggleDrawer = function (isOpen) { return function () {
        setOpen(isOpen);
        if (isOpen) {
            setLocalFilters(__assign({}, filters));
        }
    }; };
    var handleFilterChange = function (name, value) {
        var _a;
        setLocalFilters(__assign(__assign({}, localFilters), (_a = {}, _a[name] = value, _a)));
    };
    var handleConfirm = function () {
        setFilters(localFilters);
        setOpen(false);
    };
    var handleClearFilters = function () {
        setLocalFilters({});
    };
    return (_jsxs(_Fragment, { children: [_jsx(Button, { variant: "outlined", onClick: toggleDrawer(true), sx: {
                    color: color === 'white' ? '#FFFFFF' : 'primary.main',
                    borderColor: color === 'white' ? '#FFFFFF' : 'primary.main',
                    borderRadius: '30px',
                    textTransform: 'none',
                    padding: '0.5em 1.5em',
                    fontSize: '.7rem',
                    margin: '.5rem',
                    '& + &': {
                        marginLeft: '1rem',
                    },
                }, endIcon: _jsx(ArrowDropDownIcon, { sx: { color: '#A2B6DF' } }), children: "Filtrar" }), _jsx(Drawer, { anchor: "bottom", open: open, onClose: toggleDrawer(false), children: _jsxs(Container, { sx: { padding: '4rem 2rem' }, children: [_jsxs(Box, { sx: {
                                display: 'flex',
                                justifyContent: 'space-between',
                                marginBottom: '2rem',
                            }, children: [_jsx(Typography, { variant: "h6", gutterBottom: true, children: "Filtrar" }), _jsx(Button, { variant: "text", onClick: handleClearFilters, startIcon: _jsx(ClearIcon, {}), children: "Limpar" })] }), _jsx(Grid, { container: true, spacing: 2, children: filterFields.map(function (field, index) {
                                var _a;
                                var key = "filter-field-".concat(index);
                                return (_jsxs(Grid, { size: { xs: 12, md: 6 }, children: [field.type === 'text' && (_jsx(TextField, { label: field.label, value: localFilters[field.name] || '', onChange: function (e) {
                                                return handleFilterChange(field.name, e.target.value);
                                            }, fullWidth: true })), field.type === 'select' && (_jsx(TextField, { label: field.label, select: true, value: localFilters[field.name] || '', onChange: function (e) {
                                                return handleFilterChange(field.name, e.target.value);
                                            }, fullWidth: true, children: (_a = field.options) === null || _a === void 0 ? void 0 : _a.map(function (option) { return (_jsx(MenuItem, { value: option.value, children: option.label }, option.value)); }) }))] }, key));
                            }) }), _jsxs(Box, { sx: { marginTop: 2 }, children: [_jsx(Button, { variant: "contained", onClick: handleConfirm, sx: { mr: 1 }, children: "Confirmar" }), _jsx(Button, { variant: "outlined", onClick: toggleDrawer(false), children: "Voltar" })] })] }) })] }));
};
